import { useApolloClient, useSubscription } from '@apollo/client';
import { FC } from 'react';
import { GATE_MESSAGE_RECEIVED } from '../graphql/subscriptions/gateMessageReceived';
import { refreshGateMovementsHistory } from '../utils/refreshGateMovementsHistory';

interface Props {
  /**
   * Acota la suscripción a una sola compuerta (AMARU-862/US-006). Sin este prop se mantiene el
   * comportamiento histórico — entrega mensajes de toda compuerta accesible — que es lo que usa
   * el montaje global (`GlobalComponents`) para refrescar tableros con varias compuertas a la
   * vez. El modal de operación monta una instancia aparte con su propio `gateId`: no reemplaza
   * al montaje global, lo complementa para ese consumidor puntual.
   */
  gateId?: string;
}

export const GateMessagesSubscription: FC<Props> = ({ gateId }) => {
  const client = useApolloClient();

  useSubscription(GATE_MESSAGE_RECEIVED, {
    variables: { gateId },
    onData({ data }) {
      const messageGateId = data.data?.gateMessageReceived.movements.id;
      if (!messageGateId) return;

      void refreshGateMovementsHistory(client, messageGateId);
    },
  });

  return null;
};
